<div class="login-new" id="reset-password-container">
       <div class="onboarding-progress-container">
              <div class="onboarding-progress">
                     <span class="progress completed"></span>
                     <span class="progress completed"></span>
                     <span class="progress completed"></span>
                     <span class="progress active"></span>
                     <span class="progress"></span>
              </div>
              <p><strong>4</strong> of 5</p>
       </div>
       <div>
              <h5 class="onboarding-title">{{'details_about_your_org' | translate}}</h5>
       </div>
       <div>
              <form>
                     <div class="one-col-grid input-no-margin">
                            <ds-textbox #orgNameField
                                   [textboxInput]="orgNameConfig"
                                   (valueChange)="orgNameChange($event)">
                            </ds-textbox>
                            <div class="eod-input mb-0"
                            id="claimant-range-input">
                                   <label for="claimant-range" class="form-label">{{'number_of_claimants' | translate }}<span>*</span></label>
                                   <ng-select
                                   [items]="claimantRangeList"
                                   bindLabel="rangeLabel"
                                   bindValue="claimantRangeMasterId"
                                   [(ngModel)]="selectedClaimantRangeId"
                                   (change)="onClaimantRangeChange()"
                                   class="select-dropdown select-dropdown--lg"
                                   [clearable]="false"
                                   notFoundText="{{'no_data_available' | translate}}"
                                   name="claimantRange">
                                   </ng-select>
                                   @if(submitted && !selectedClaimantRangeId){<small class="helper-text">{{"number_of_claimants_is_required" | translate}}</small>}
                            </div>
                            <div class="d-flex no-input-margin gap-12">
                                   <div class="eod-input w-100pc"
                                          id="country-input">
                                          <label for="country" class="form-label">{{'country' | translate }}<span>*</span></label>
                                          <ng-select
                                          [items]="countryList"
                                          bindLabel="countryName"
                                          bindValue="countryId"
                                          [(ngModel)]="selectedCountryId"
                                          (change)="onCountryChange()"
                                          class="select-dropdown select-dropdown--lg"
                                          [clearable]="false"
                                          notFoundText="{{'no_data_available' | translate}}"
                                          name="country">
                                          </ng-select>
                                          @if(submitted && !selectedCountryId){<small class="helper-text">{{"country_is_required" | translate}}</small>}
                                   </div>
                                   @if(countryList && countryList.length>0){<ds-textbox class="w-100pc"
                                   [textboxInput]="currencyConfig">
                                   </ds-textbox>}
                            </div>
                            <ds-textbox
                                   [textboxInput]="phoneConfig"
                                   (valueChange)="onPhoneChange($event)">
                            </ds-textbox>
                     </div>
                     
              </form>
       </div>
       <ds-button
              [buttonInput]="continueConfig"
              (btnClick)="onSubmit()"
       ></ds-button>
</div>